import { useMemo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useHomeCurrency } from '../../../v2/hooks/useHomeCurrency';
import { getPricingModelLabel } from '../constants/pricingModel';
import { TieredPriceCurrencySelect } from './header/TieredPriceCurrencySelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceModalHeaderSection = ({
  effectiveCurrencyCode,
  currencyCodesWithTiersData,
  pricingModel,
  setEffectiveCurrencyCode
}) => {
  const pricingModelLabel = getPricingModelLabel(pricingModel);
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const currencyCodeToDisplay = useMemo(() => {
    if (effectiveCurrencyCode === undefined && homeCurrencyCode === undefined) {
      return undefined;
    }
    return effectiveCurrencyCode !== null && effectiveCurrencyCode !== void 0 ? effectiveCurrencyCode : homeCurrencyCode;
  }, [effectiveCurrencyCode, homeCurrencyCode]);
  if (currencyCodeToDisplay === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsx(HelpIcon, {
      "data-test-id": "tiered-price-modal-pricing-method-help-icon",
      title: pricingModelLabel === null || pricingModelLabel === void 0 ? void 0 : pricingModelLabel.help,
      tooltipPlacement: "top",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "tiered-price-modal-pricing-method-info",
        message: "customerDataProperties.tieredPricing.modal.pricingMethodInfo",
        options: {
          pricingModel: pricingModelLabel === null || pricingModelLabel === void 0 ? void 0 : pricingModelLabel.label
        }
      })
    }), /*#__PURE__*/_jsx(TieredPriceCurrencySelect, {
      effectiveCurrencyCode: currencyCodeToDisplay,
      currencyCodesWithData: currencyCodesWithTiersData,
      setEffectiveCurrencyCode: setEffectiveCurrencyCode
    })]
  });
};